import { RegisteredTokenDetail } from "models/factory/RegisteredTokenResponse"
import { ConfigResponse } from "models/staking/ConfigResponse"
import { TokenInfoResponse } from "models/token/TokenInfoResponse"
import { copy, currency, fromDenom } from "utils/Helpers"

type Props = { tokenInfo?: TokenInfoResponse, config?: ConfigResponse, tokenDetail?: RegisteredTokenDetail, pool?: number }

export function TokenDetailForm({ tokenDetail, tokenInfo, config, pool }: Props) {
    return <div>
        <div className="mb-3">
            <label htmlFor="token-address" className="form-label">CW20 Address</label>
            <div className="input-group">
                <input
                    value={tokenDetail?.token_address}
                    readOnly
                    id="token-address"
                    type="text"
                    className="form-control"
                />
                <button onClick={() => copy(tokenDetail?.token_address ?? "")} className="btn btn-outline-primary" type="button">Copy</button>
            </div>
        </div>
        <div className="row mb-3">
            <div className="col-8">
                <label htmlFor="token-name" className="form-label">Name</label>
                <div className="input-group">
                    <input
                        value={tokenInfo?.name}
                        readOnly
                        id="token-name"
                        type="text"
                        className="form-control"
                    />
                </div>

            </div>
            <div className="col-4">
                <label htmlFor="token-symbol" className="form-label">Symbol</label>
                <div className="input-group">
                    <input
                        value={tokenInfo?.symbol}
                        readOnly
                        id="token-symbol"
                        type="text"
                        className="form-control"
                    />
                </div>
            </div>
        </div>
        <div className="mb-3">
            <label htmlFor="staking-address" className="form-label">Staking Address</label>
            <div className="input-group">
                <input
                    value={tokenDetail?.staking_address}
                    readOnly
                    id="staking-address"
                    type="text"
                    className="form-control"
                />
                <button onClick={() => copy(tokenDetail?.staking_address ?? "")} className="btn btn-outline-primary" type="button">Copy</button>
            </div>
        </div>
        <div className="row mb-3">
            <div className="col-6">
                <label htmlFor="staking-apr" className="form-label">APR</label>
                <div className="input-group">
                    <input
                        value={(Number(config?.config.apr ?? "0") * 100) + "%"}
                        readOnly
                        id="staking-apr"
                        type="text"
                        className="form-control"
                    />
                </div>
            </div>
            <div className="col-6">
                <label htmlFor="duration" className="form-label">Unstake Duration</label>
                <div className="input-group">
                    <input
                        value={Number(config?.config.unstake_duration ?? "0") + " Days"}
                        readOnly
                        id="duration"
                        type="text"
                        className="form-control"
                    />
                </div>
            </div>
        </div>
        <div className="mb-3">
            <label htmlFor="current-pool" className="form-label">Current Pool</label>
            <div className="input-group">
                <input
                    value={currency(fromDenom(pool ?? 0, tokenInfo?.decimals ?? 0)) + " " + (tokenInfo?.symbol ?? "")}
                    readOnly
                    id="current-pool"
                    type="text"
                    className="form-control"
                />
            </div>
        </div>
    </div>
}